import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Flex,
  Icon
} from '@chakra-ui/react';
import { NavigationItem } from './nav-item';
import { NavigationSection as NavigationSectionType } from '@lib/docs/types';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { isNavigationItemOfType } from '@lib/docs/nav';
import { makeDocsLink } from '@lib/docs/utils';

type NavigationSectionProps = {
  config: NavigationSectionType;
  activePath: string;
};

/**
 * Adapted from https://github.com/clerkinc/dashboard/blob/main/components/sidebar/NavExpandable.tsx
 */
export function NavigationSection({
  config,
  activePath
}: NavigationSectionProps): JSX.Element {
  const [textConfig, items] = config;

  /**
   * Check if the current path exists in the section's children,
   * and if it is, set the accordion to be expanded
   */
  const shouldBeExpanded = items.some(item =>
    isNavigationItemOfType(item, 'link')
      ? makeDocsLink(item[1]) === activePath
      : false
  )
    ? [0]
    : undefined;

  return (
    <Accordion allowToggle variant="sidenav" defaultIndex={shouldBeExpanded}>
      <AccordionItem
        sx={{
          '.chakra-collapse': {
            overflow: 'initial !important'
          }
        }}
      >
        {({ isExpanded }) => (
          <>
            <AccordionButton
              /* remove click focus */
              _focus={{}}
            >
              <Flex alignItems="center" justify="space-between" width="100%">
                <NavigationItem item={textConfig} activePath={activePath} />
                <Icon
                  as={ChevronDownIcon}
                  boxSize={5}
                  color="gray.300"
                  transform={`rotate(${isExpanded ? '0' : '-90'}deg)`}
                  transition="transform 0.2s"
                />
              </Flex>
            </AccordionButton>

            <AccordionPanel pl={2}>
              {items.map(item => (
                <NavigationItem
                  key={JSON.stringify(item)}
                  item={item}
                  activePath={activePath}
                />
              ))}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
}
